import PropTypes from 'prop-types';
import { InfoIcon, WarningTriangle } from 'assets/icons';
import { information } from 'constants/variables';

const AlertBox = ({
  className,
  variant = 'info',
  showIcon = true,
  iconHeight,
  title,
  body,
  bodyClass,
}) => (
  <div
    className={`plr-10 ptb-12 fs-14 fl cef-ui-alertbox cef-ui-alertbox--${variant} ${
      className || ''
    }`}>
    {showIcon && (
      <div className={`mr-10 lh-0 cef-ui-alertbox--${variant}-icon`}>
        {/* TODO: Add icons for other variants when required */}
        {variant === 'info' && (
          <InfoIcon fillColor={information} height={iconHeight || ''} />
        )}
        {variant === 'error' && <WarningTriangle height={iconHeight || ''} />}
      </div>
    )}
    <div>
      {title && <p className="mb-0 fw-600">{title}</p>}
      {body && (
        <p
          className={`mb-0 ${bodyClass || ''}`}
          dangerouslySetInnerHTML={{ __html: body }}
        />
      )}
    </div>
  </div>
);

AlertBox.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['info', 'success', 'error']),
  showIcon: PropTypes.bool,
  iconHeight: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  bodyClass: PropTypes.string,
};

export default AlertBox;
